import { MessageChunk, RagSource } from '@/models/thread';

export const getToday = (): Date => new Date();

export const getTodayStr = (): string => convertDateToString(getToday());

export const dateDiffInDays = (a: Date, b: Date): number => {
  const dateA = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const dateB = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((dateB - dateA) / (1000 * 60 * 60 * 24));
};

export const convertDateToString = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

export const getRandomNumber = (min: number, max: number): number => {
  return Math.random() * (max - min) + min; // Random
};

export const convertTimestampToString = (timestamp: number): string => {
  if (Number.isNaN(timestamp) || timestamp === 0) return '';
  return convertDateToString(new Date(timestamp));
};

export const truncateText = (text: string, limit: number): string => {
  if (text === null) return '';
  if (text.length > limit) {
    return text.substring(0, limit) + '...';
  } else {
    return text;
  }
};

export const extractBaseURL = (url: string): string => {
  const matchArray = url.match(/^(https?:\/\/[^/]+)/);

  return matchArray ? matchArray[1] : url;
};

export const classnames = (
  ...args: (string | Record<string, boolean>)[]
): string => {
  const classes = [];

  for (const arg of args) {
    if (!arg) continue;

    const argType = typeof arg;

    if (argType === 'string') {
      classes.push(arg);
    } else if (argType === 'object') {
      const obj = arg as Record<string, boolean>;

      Object.keys(obj).forEach((key) => {
        if (obj[key]) {
          classes.push(key);
        }
      });
    }
  }

  return classes.join(' ');
};

export const parseFullMessage = (
  response: string,
  ragSources: Array<RagSource>
): MessageChunk[] => {
  const res: MessageChunk[] = [];
  if (!response) return res;

  response = response.replace(/(\[\d+\])+\s*\./g, '$1');
  const regex = /([\s\S]*?)\s*((\[(\d+)\]\s?)+)/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(response)) !== null) {
    const text = match[1].trim();
    const citationsChain = match[2].trim();
    const citationRegex = /\[(\d+)\]/g;
    let citationMatch;
    const citationIds: Array<number> = [];

    while ((citationMatch = citationRegex.exec(citationsChain)) !== null) {
      const id = parseInt(citationMatch[1], 10);
      citationIds.push(id);
    }

    if (text) {
      res.push({
        text,
        citation: citationIds.map((citationId) => {
          const source = ragSources.find(
            (source) => source.source_id === citationId
          );
          if (!source) {
            return { source_id: citationId, details: [] };
          }
          return {
            source_id: citationId,
            details: source.related_chunks.map((chunk) => ({
              content: chunk,
              relevance: '',
            })),
          };
        }),
      });
    }
    lastIndex = regex.lastIndex;
  }

  // Add any remaining text after the last citation
  if (lastIndex < response.length) {
    const remaining = response.slice(lastIndex).trim();
    if (remaining) {
      res.push({
        text: remaining,
        citation: [],
      });
    }
  }

  return res;
};
